
import { Box, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const SensoryAndCommunicationSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  const sectionsGrp1 = [
    { name: "sensoryAndComm.hearingSpeaking", label: "child-patient-assessment.hearing-speaking", desc: "sensoryAndComm.hearingSpeakingDescription" },
    { name: "sensoryAndComm.vision", label: "child-patient-assessment.vision", desc: "sensoryAndComm.visionDescription" },
    { name: "sensoryAndComm.prosthetics", label: "child-patient-assessment.prosthetics", desc: "sensoryAndComm.prostheticsDescription" },
  ];

  const sectionsGrp2 = [
    { name: "sensoryAndComm.communicationStatus", label: "child-patient-assessment.communication-status", desc: "sensoryAndComm.communicationStatusDescription" },
    { name: "sensoryAndComm.psychological", label: "child-patient-assessment.psychological", desc: "sensoryAndComm.psychologicalDescription" },
    { name: "sensoryAndComm.schoolStatus", label: "child-patient-assessment.school-status", desc: "sensoryAndComm.schoolStatusDescription" },
    { name: "sensoryAndComm.mobility", label: "child-patient-assessment.mobility", desc: "sensoryAndComm.mobilityDescription" },
  ];

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <Grid container spacing={2}>
        {sectionsGrp1.map((sec) => (
          <Grid key={sec.name} md={2} xs={6}>
            <ByzTitleAndInputBox marginLeft="0px" title={t(sec.label)}>
              <Controller
                name={sec.name}
                control={control}
                render={({ field }) => (
                  <ByzMuiSelect {...field} options={[]} label={t("open-process-menu.select", "capitalize")} sx={{ pt: 1 }} />
                )}
              />
              <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "8px" }} title={t("description", "capitalize")}>
                <Controller
                  name={sec.desc}
                  control={control}
                  render={({ field }) => (
                    <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
                  )}
                />
              </ByzTitleAndInputBox>
            </ByzTitleAndInputBox>
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ borderColor: "black", borderBottomWidth: "2px", my: 2 }} />

      <Grid container spacing={2}>
        {sectionsGrp2.map((sec) => (
          <Grid key={sec.name} md={2} xs={6}>
            <ByzTitleAndInputBox marginLeft="0px" title={t(sec.label)}>
              <Controller
                name={sec.name}
                control={control}
                render={({ field }) => (
                  <ByzMuiSelect {...field} options={[]} label={t("open-process-menu.select", "capitalize")} sx={{ pt: 1 }} />
                )}
              />
              <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "8px" }} title={t("description", "capitalize")}>
                <Controller
                  name={sec.desc}
                  control={control}
                  render={({ field }) => (
                    <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
                  )}
                />
              </ByzTitleAndInputBox>
            </ByzTitleAndInputBox>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
